var path = 'src/app/patients/navigation/system-navigation.html';
var html = "<div class=patient-nav> <ul> <li class=radar> {{system.shortName}} </li> <li ui-sref-active=active ng-repeat=\"item in items\"> <a ui-sref={{item.state}}>{{item.name}}</a> </li> <li ui-sref-active=active> <a ui-sref=\"patient.all({patientId: patient.id})\">More&hellip;</a> </li> </ul> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/patients/navigation/system-navigation.html
 ** module id = 539
 ** module chunks = 0
 **/